"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.tempUploadForge = exports.rootRefs = exports.byOrgIdUserIdAll = exports.bySceneId = exports.orgByProjectId = exports.byProjectId = exports.originalModel = exports.originalMisc = exports.modelVersionFiles = exports.byModelId = exports.byUserId = exports.byOrgIdUserId = exports.byOrgId = void 0;
/* eslint-disable @typescript-eslint/explicit-function-return-type */
exports.byOrgId = (orgId) => {
    return {
        orgStats: `organizations/${orgId}/stats`,
        orgSetting: `orgData/${orgId}/orgSetting`,
        resources: `orgData/${orgId}/resources`,
        activeInstalments: `orgData/${orgId}/activeInstalments`,
        resourceEvents: `orgData/${orgId}/resourceEvents`,
        units: `orgData/${orgId}/units`,
        unitsConfigs: `orgData/${orgId}/unitsConfigs`,
        users: `orgData/${orgId}/users`,
        usersStats: `orgData/${orgId}/usersStats`,
        customRoleDefs: `orgData/${orgId}/customRoleDefs`,
        modelInstances: `orgData/${orgId}/modelInstances`,
        projectsOrg: `orgData/${orgId}/projects/ORG`,
        projectsPublic: `orgData/${orgId}/projects/PUBLIC`,
        orgModels: `orgData/${orgId}/models/ORG`,
        modelsPublic: `orgData/${orgId}/models/PUBLIC`,
        rolesAllUsers: `orgData/${orgId}/roles`,
        projectsByUser: `orgData/${orgId}/projects`,
        orgConfig: `orgConfigs/${orgId}`,
        services: `orgConfigs/${orgId}/services`,
        externalData: `orgConfigs/${orgId}/externalData`,
        customDataSchemas: `orgConfigs/${orgId}/customDataSchemas`,
        webTheme: `orgConfigs/${orgId}/webTheme`,
        appTheme: `orgConfigs/${orgId}/appTheme`,
        customLogo: `orgConfigs/${orgId}/customLogo`,
        customLogoMobile: `orgConfigs/${orgId}/customLogo/mobile`,
        customLogoDesktop: `orgConfigs/${orgId}/customLogo/desktop`,
        sendInBlueTemplateOverrides: `orgConfigs/${orgId}/sendInBlueTemplateOverrides`,
    };
};
exports.byOrgIdUserId = (orgId, userId) => {
    return {
        roles: `orgData/${orgId}/roles/${userId}`,
        projects: `orgData/${orgId}/projects/${userId}`,
        scenes: `orgData/${orgId}/scenes/${userId}`,
        models: `orgData/${orgId}/models/${userId}`,
        portalUiPermissions: `orgData/${orgId}/portalUiPermissions/${userId}`,
        appUiPermissions: `orgData/${orgId}/appUiPermissions/${userId}`,
        rootDbPermissions: `orgData/${orgId}/rootDbPermissions/${userId}`,
        rootStoragePermissions: `orgData/${orgId}/rootStoragePermissions/${userId}`,
        portalUiViews: `orgData/${orgId}/portalUiViews/${userId}`,
        appUiViews: `orgData/${orgId}/appUiViews/${userId}`,
    };
};
exports.byUserId = (userId) => {
    return {
        fcmTokens: `fcmTokens/${userId}`,
        gWorkers: `gWorkers/${userId}`,
        gWorkerErrors: `gWorkerErrors/${userId}`,
        machineManagers: `machineManagers/${userId}`,
        machineLogs: `machineLogs/${userId}`,
        sharedModels: `sharingData/sharedModels/${userId}`,
        sharedProjects: `sharingData/sharedProjects/${userId}`,
        sharedScenes: `sharingData/sharedScenes/${userId}`,
        sharedModelsPerUser: `sharingData/sharedModelsPerUser/${userId}`,
    };
};
exports.byModelId = (orgId, userId, modelId) => {
    return {
        model: `orgData/${orgId}/models/${userId}/${modelId}`,
        modelVersions: `orgData/${orgId}/models/${userId}/${modelId}/modelVersions`,
    };
};
exports.modelVersionFiles = (orgId, userId, modelId, modelVersionOrdKey) => `orgData/${orgId}/models/${userId}/${modelId}/modelVersions/${modelVersionOrdKey}/files`;
exports.originalMisc = (orgId, userId, modelId, modelVersionOrdKey) => `orgData/${orgId}/models/${userId}/${modelId}/modelVersions/${modelVersionOrdKey}/files/original/misc`;
exports.originalModel = (orgId, userId, modelId, modelVersionOrdKey) => `orgData/${orgId}/models/${userId}/${modelId}/modelVersions/${modelVersionOrdKey}/files/original/model`;
exports.byProjectId = (orgId, userId, projectId) => {
    return {
        project: `orgData/${orgId}/projects/${userId}/${projectId}`,
        projectScenes: `orgData/${orgId}/projects/${userId}/${projectId}/scenes`,
        projectScenesCnt: `orgData/${orgId}/projects/${userId}/${projectId}/scenesCnt`,
        scenes: `orgData/${orgId}/scenes/${userId}/${projectId}`,
    };
};
exports.orgByProjectId = (orgId, projectId) => {
    return {
        orgScenes: `orgData/${orgId}/scenes/ORG/${projectId}`,
        publicScenes: `orgData/${orgId}/scenes/PUBLIC/${projectId}`,
    };
};
exports.bySceneId = (orgId, userId, projectId, sceneId) => {
    return {
        scene: `orgData/${orgId}/scenes/${userId}/${projectId}/${sceneId}`,
        cameraViews: `orgData/${orgId}/scenes/${userId}/${projectId}/${sceneId}/cameraViews`,
        augmentedImages: `orgData/${orgId}/scenes/${userId}/${projectId}/${sceneId}/augmentedImages`,
        modelInstances: `orgData/${orgId}/scenes/${userId}/${projectId}/${sceneId}/modelInstances`,
    };
};
exports.byOrgIdUserIdAll = (ctx) => {
    return {
        ...exports.byOrgId(ctx.orgId),
        ...exports.byUserId(ctx.userId),
        ...exports.byOrgIdUserId(ctx.orgId, ctx.userId),
    };
};
exports.rootRefs = {
    tempUpload: "tempUpload",
    orgData: "orgData",
    accounts: "accounts",
    organizations: "organizations",
    orgConfigs: "orgConfigs",
    instalmentTemplates: "instalmentTemplates",
    removedUser: "removedUser",
    userOrgMap: "userOrgMap",
    userEmailMap: "userEmailMap",
    commonData: "commonData",
    salesOfferings: "commonData/internal/salesOfferings",
    tutorialsVideo: "commonData/internal/tutorials/video",
    globalState: "globalState",
    currentTurnaroundHours: "globalState/currentTurnaroundHours",
    automationEmail: "globalState/automationEmail",
    graphicsEmail: "globalState/graphicsEmail",
    jiraTaskProjectId: "globalState/jiraTaskProjectId",
    forgeAppConfig: "globalState/forgeAppConfig",
    pixyzGlobalConfig: "globalState/pixyzGlobalConfig",
    awsCredentials: "globalState/awsCredentials",
    portalUiPermissions: "globalState/portalUiPermissions",
    gWorkerMonitoring: "globalState/gWorkerMonitoring",
    gWorkerMonitoringEmails: "globalState/gWorkerMonitoring/emails",
    gWorkerMonitoringEmailRate: "globalState/gWorkerMonitoring/emailRate",
    gWorkerMonitoringLastSentAt: "globalState/gWorkerMonitoring/lastSentAt",
    publicConfig: "publicConfig",
    supportEmail: "publicConfig/supportEmail",
    jiraSupportTicketProjectId: "publicConfig/jiraSupportTicketProjectId",
    sharingData: "sharingData",
    modelInfo: "modelInfo",
    taskHistory: "taskHistory",
    taskQueue: "taskQueue",
    modelProcessingRequests: "modelProcessingRequests",
    diagnostics: "diagnostics",
    processingSummaries: "processingSummaries",
    processingFlows: "processingFlows",
    modelProcessingRequestTemplates: "modelProcessingRequestTemplates",
    diagnosticTemplates: "diagnosticTemplates",
    processingFlowTemplates: "processingFlowTemplates",
    gWorkers: "gWorkers",
    gWorkerLogs: "gWorkerLogs",
    gWorkerLogsTaskSteps: "gWorkerLogs/taskSteps",
    gWorkerLogsJobs: "gWorkerLogs/jobs",
    gWorkerErrors: "gWorkerErrors",
    loadBalancer: "loadBalancer",
    dbMaintenance: "dbMaintenance",
    jiraIssue: "jiraIssue",
    successActionLogs: "successActionLogs",
    failedActionLogs: "failedActionLogs",
    orgInvites: "orgInvites",
    customClaims: "customClaims",
    webPresence: "webPresence",
    webSessions: "webSessions",
    fcmTokens: "fcmTokens",
    userMigrationStatus: "userMigrationStatus",
    revokedTokens: "revokedTokens",
    platformStats: "platformStats",
    forgeAppSessions: "forgeAppSessions",
    formConfigs: "formConfigs",
    services: "services",
    apps: "apps",
    pixyzConfigs: "pixyzConfigs",
};
exports.default = {
    rootRefs: exports.rootRefs,
    builder: {
        byOrgIdUserIdAll: exports.byOrgIdUserIdAll,
        byOrgIdUserId: exports.byOrgIdUserId,
        byProjectId: exports.byProjectId,
        orgByProjectId: exports.orgByProjectId,
        byModelId: exports.byModelId,
        bySceneId: exports.bySceneId,
        byUserId: exports.byUserId,
        byOrgId: exports.byOrgId,
    },
};
exports.tempUploadForge = (projectId, versionId, name) => `tempUpload/forge/${projectId}/versionId/${name}`;
//# sourceMappingURL=DatabaseRefs.js.map